<div class="basicrow m-top">
  <div class="autowcont mbott">
    <div class="basicrow msidespad">
      <div class="b-title">
        <div class="autocont f-black roboto-m f-bmed pull-left vcenter">
          <div class="tabcell">
            Plan
          </div>
        </div>
      </div>
    </div>
    <div class="basicrow msidespad roboto-r m-bott f-reg f-black">
      <div class="device-ii firsth roboto-b">
        <div class="userinfo full">
          <div class="basicrow f-black roboto-b f-bmed">
            Detalle del Plan
          </div>
          <div class="redstat m-top-ii">
            <div class="autorow roboto-r pull-left">
              Plan Actual
            </div>
            <div class="autorow roboto-b pull-right">
              {{this.plan_price|currency}}
            </div>
          </div>
          <div class="redstat m-top-ii">
            <div class="autorow roboto-r pull-left">
              Nombre
            </div>
            <div class="autorow roboto-b pull-right">
              {{this.plan_name}}
            </div>
          </div>
        </div>
        <div class="basicrow m-top">
          <span class="roboto-b">Descripcion del Plan:</span>
          <div class="basicrow normdef f-reg roboto-r" [innerHTML]="this.plan_description"></div>
        </div>
      </div>
      <div class="device-ii lasth roboto-r" *ngIf="this.additional_serv.length > 0">
        <div class="userinfo full">
          <div class="basicrow f-black roboto-b f-bmed">
            Servicios Adicionales
          </div>
          <div class="redstat m-top-ii" *ngFor="let sva of this.additional_serv; let j= index">
            <div class="autorow roboto-r pull-left">
              {{sva.sOCDescField}}
            </div>
            <div class="autorow roboto-b pull-right">
              {{sva.socRateField | currency}}
            </div>
          </div>
        </div>
        <div class="basicrow text-center m-top">
          <div class="basicrow m-top-u roboto-b">
            Renta Mensual
          </div>
          <div class="basicrow roboto-m f-semi f-red">
            {{this.totalRateField|currency}}
          </div>
        </div>
      </div>
      <div class="device-ii last roboto-b text-center vertical" *ngIf="this.additional_serv.length == 0">
        <div class="basicrow text-center m-top">
          <div class="basicrow m-top-u roboto-b">
            Renta Mensual
          </div>
          <div class="basicrow roboto-m f-semi f-red">
            {{this.totalRateField|currency}}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>